/**
 * Adds client-side sorting by height boost, triggered from two extra options
 * ("Height Boost: Most first" / "Least first") added directly to the native
 * sort_by dropdown in facets.liquid. Shopify's collection sort_by has no
 * metafield option, so the value is a sentinel the server ignores — this
 * script reorders the already-rendered grid using each card's
 * data-height-boost attribute (from the custom.height_boost metafield).
 */
(function () {
  var DESC = 'height-boost-desc';
  var ASC = 'height-boost-asc';
  var isProgrammaticSort = false;

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getCurrentSortValue() {
    var select = document.querySelector('select[name="sort_by"]');
    return select ? select.value : '';
  }

  function sortGrid(direction) {
    var grid = getGrid();
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    if (!items.length) return;

    items.sort(function (a, b) {
      var av = parseFloat(a.getAttribute('data-height-boost'));
      var bv = parseFloat(b.getAttribute('data-height-boost'));
      var aValid = !isNaN(av);
      var bValid = !isNaN(bv);
      if (!aValid && !bValid) return 0;
      if (!aValid) return 1;
      if (!bValid) return -1;
      return direction === 'height-boost-asc' ? av - bv : bv - av;
    });

    isProgrammaticSort = true;
    items.forEach(function (item) {
      grid.appendChild(item);
    });
    setTimeout(function () {
      isProgrammaticSort = false;
    }, 0);
  }

  function applyCurrentSort() {
    var value = getCurrentSortValue();
    if (value === DESC || value === ASC) sortGrid(value);
  }

  function onSortChange(event) {
    var target = event.target;
    if (!target.matches('select[name="sort_by"]')) return;
    if (target.value === DESC || target.value === ASC) {
      // Apply immediately for instant feedback; Dawn's own debounced fetch
      // will still run and replace the grid, but the MutationObserver below
      // reapplies the sort once that settles.
      sortGrid(target.value);
    }
  }

  function init() {
    applyCurrentSort();

    document.addEventListener('change', onSortChange);

    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      var observer = new MutationObserver(function () {
        if (isProgrammaticSort) return;
        applyCurrentSort();
      });
      observer.observe(gridContainer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
